import { MediaItemTypes } from '../types/content';
export var images = [
    {
        Description: '',
        Link: {},
        Title: 'Misty Slope',
        height: 1280,
        mediaType: 'image',
        relativeUri: '99ec98fdb81945c29c25a3ad6c5606b1.jpg',
        width: 1920,
        locales: ['all'],
        geo: ['all'],
    },
    {
        Description: '',
        Link: {},
        Title: 'Taj Mahal',
        height: 1275,
        mediaType: 'image',
        relativeUri: 'd967ba93f0314c78924edc8a8c8cfa15.jpg',
        width: 1920,
        locales: ['all'],
        geo: ['all'],
    },
    {
        Description: '',
        Link: {},
        Title: 'Palm Trees',
        height: 1280,
        mediaType: 'image',
        relativeUri: '3cd1de924697419088c1e033bb3384ef.jpg',
        width: 1920,
        locales: ['all'],
        geo: ['all'],
    },
];
export var clipart = {
    Title: 'Black and White Star in Circle',
    mediaType: 'clipart',
    relativeUri: '13128652dab8451db4ce3e8b1b00d5b0.png',
    uri: '13128652dab8451db4ce3e8b1b00d5b0.png',
    fileUrl: 'media/13128652dab8451db4ce3e8b1b00d5b0.png',
    width: 378,
    height: 349,
    locales: ['all'],
    geo: ['all'],
};
export var shape = {
    Description: '',
    Link: {},
    Title: 'Graphic Shape 4',
    mediaType: 'shape',
    relativeUri: 'shapes/ef5946b66a704127a057a586d04e7e48.svg',
    width: 200,
    height: 200,
    locales: ['all'],
    geo: ['all'],
};
export var extVideo = {
    videoUrl: 'https://youtu.be/Pdq8ddrLd1A',
    videoId: 'Pdq8ddrLd1A',
    thumbnailUrl: 'https://i.ytimg.com/vi/Pdq8ddrLd1A/hqdefault.jpg',
    width: 480,
    height: 360,
    Title: 'Wix default video',
    Description: '',
    mediaType: 'extVideo',
    active: true,
    controls: 1,
    playmode: {
        autoplay: true,
        loop: false,
    },
    locales: ['all'],
    geo: ['all'],
};
export var bgVideo = {
    mediaType: MediaItemTypes.Video,
    uri: '11062b_3e2f37c297534f9ead156265242fbca8',
    fileUrl: 'video/11062b_3e2f37c297534f9ead156265242fbca8',
    title: 'Urban View',
    fileInput: {
        audioBitrate: 196,
        videoBitrate: 10082,
        height: 1080,
        width: 1920,
        fps: 25,
        duration: 19600,
        type: 'video',
        displayAspectRatio: '16:9',
    },
    fileOutput: {
        image: [
            {
                status: 'READY',
                secure: false,
                format: 'jpg',
                url: 'media/11062b_3e2f37c297534f9ead156265242fbca8f000.jpg',
                height: 1080,
                width: 1920,
                key: 'poster.0',
            },
            {
                status: 'READY',
                secure: false,
                format: 'jpg',
                url: 'media/11062b_3e2f37c297534f9ead156265242fbca8f001.jpg',
                height: 1080,
                width: 1920,
                key: 'poster.1',
            },
            {
                status: 'READY',
                secure: false,
                format: 'jpg',
                url: 'media/11062b_3e2f37c297534f9ead156265242fbca8f002.jpg',
                height: 1080,
                width: 1920,
                key: 'poster.2',
            },
            {
                status: 'READY',
                secure: false,
                format: 'jpg',
                url: 'media/11062b_3e2f37c297534f9ead156265242fbca8f003.jpg',
                height: 1080,
                width: 1920,
                key: 'poster.3',
            },
        ],
        video: [
            {
                status: 'READY',
                audioBitrate: -1,
                secure: false,
                fps: 25,
                format: 'mp4',
                url: 'video/11062b_3e2f37c297534f9ead156265242fbca8/480p/mp4/file.mp4',
                height: 480,
                videoBitrate: 877,
                tag: 'High',
                key: '480p.mp4',
                duration: 19600,
                displayAspectRatio: '16:9',
                quality: '480p',
                width: 854,
            },
            {
                status: 'READY',
                audioBitrate: -1,
                secure: false,
                fps: 25,
                format: 'webm',
                url: 'video/11062b_3e2f37c297534f9ead156265242fbca8/480p/webm/file.webm',
                height: 480,
                videoBitrate: 1457,
                tag: 'High',
                key: '480p.webm',
                duration: 19600,
                displayAspectRatio: '16:9',
                quality: '480p',
                width: 854,
            },
            {
                status: 'READY',
                audioBitrate: -1,
                secure: false,
                fps: 25,
                format: 'mp4',
                url: 'video/11062b_3e2f37c297534f9ead156265242fbca8/720p/mp4/file.mp4',
                height: 720,
                videoBitrate: 3362,
                tag: 'HD',
                key: '720p.mp4',
                duration: 19600,
                displayAspectRatio: '16:9',
                quality: '720p',
                width: 1280,
            },
            {
                status: 'READY',
                audioBitrate: -1,
                secure: false,
                fps: 25,
                format: 'webm',
                url: 'video/11062b_3e2f37c297534f9ead156265242fbca8/720p/webm/file.webm',
                height: 720,
                videoBitrate: 3954,
                tag: 'HD',
                key: '720p.webm',
                duration: 19600,
                displayAspectRatio: '16:9',
                quality: '720p',
                width: 1280,
            },
            {
                status: 'READY',
                audioBitrate: -1,
                secure: false,
                fps: 25,
                format: 'mp4',
                url: 'video/11062b_3e2f37c297534f9ead156265242fbca8/1080p/mp4/file.mp4',
                height: 1080,
                videoBitrate: 5753,
                tag: 'HD',
                key: '1080p.mp4',
                duration: 19600,
                displayAspectRatio: '16:9',
                quality: '1080p',
                width: 1920,
            },
            {
                status: 'READY',
                audioBitrate: -1,
                secure: false,
                fps: 25,
                format: 'webm',
                url: 'video/11062b_3e2f37c297534f9ead156265242fbca8/1080p/webm/file.webm',
                height: 1080,
                videoBitrate: 7151,
                tag: 'HD',
                key: '1080p.webm',
                duration: 19600,
                displayAspectRatio: '16:9',
                quality: '1080p',
                width: 1920,
            },
        ],
    },
    vendor: 'bigstock&bigstock&bigstock&clipcanvas',
    reference: 'v49780622&v493478872&v49737086&v318347',
    fileBaseUrl: 'video/11062b_3e2f37c297534f9ead156265242fbca8',
    relativeUri: '11062b_3e2f37c297534f9ead156265242fbca8',
    thumbnailUrl: 'https://static.wixstatic.com/media/11062b_3e2f37c297534f9ead156265242fbca8f002.jpg/v1/fit/w_288,h_155/11062b_3e2f37c297534f9ead156265242fbca8f002.jpg',
    Title: 'Urban View',
    Description: '',
    controls: 0,
    playmode: {
        autoplay: true,
        loop: true,
    },
    active: true,
    locales: ['all'],
    geo: ['all'],
};
//# sourceMappingURL=contentDefaults.js.map